import './ProductContact.css';
import { Link } from 'react-router-dom';

export default function ProductContact() {
  return (
    <section className="pc-section">
      <div className="pc-inner">

        {/* Left — Google Maps */}
        <div className="pc-map-wrap">
          <iframe
            title="Watt & Wattle Location"
            className="pc-map"
            src="https://maps.google.com/maps?q=1+Wayne+Court,+Dandenong+VIC+3175,+Australia&t=&z=15&ie=UTF8&iwloc=&output=embed"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Right — Contact info */}
        <div className="pc-info">
          <h2 className="pc-heading">Contact Us</h2>

          <div className="pc-details">
            <p className="pc-detail">
              <strong>Email:</strong> sales@wattandwattle.com.au
            </p>
            <p className="pc-detail">
              <strong>Mobile:</strong> 0414339191
            </p>
            <p className="pc-detail">
              <strong>Location:</strong> 1 Wayne Court, Dandenong, VIC, 3175
            </p>
          </div>

          <Link to="/enquiry" className="pc-btn">Get Free Quote</Link>
        </div>

      </div>
    </section>
  );
}
